export const LogoDev = ({ url, size }: { url: string; size?: number }) => {
  return (
    <img
      src={`https://img.logo.dev/${url.replace(/https?:\/\//, "")}?token=pk_MqxwLLVqT--2k2S09FbOfw`}
      alt="favicon"
      width={size ?? 16}
      height={size ?? 16}
    />
  );
};
